import React, { useEffect } from 'react';
import 'aos/dist/aos.css';
import AOS from 'aos';
import 'bootstrap-icons/font/bootstrap-icons.css';

const servicos = [
  {
    titulo: 'Ansiedade, estresse e depressão',
    descricao:
      'Apoio para lidar com preocupações constantes, sobrecarga emocional, tristeza persistente e dificuldade de desacelerar.',
    icone: 'bi-cloud-drizzle',
  },
  {
    titulo: 'Autoestima e relacionamentos',
    descricao:
      'Desenvolver uma relação mais saudável consigo mesmo(a) e com os outros, reconhecendo necessidades, limites e padrões nos vínculos.',
    icone: 'bi-person-heart',
  },
  {
    titulo: 'Terapia para adolescentes',
    descricao:
      'Acompanhamento em questões como ansiedade, autoestima, conflitos familiares, desafios escolares e escolhas para o futuro.',
    icone: 'bi-emoji-smile',
  },
  {
    titulo: 'Terapia para idosos',
    descricao:
      'Acolhimento nas mudanças do envelhecimento: aposentadoria, perdas, solidão, saúde e novos projetos de vida.',
    icone: 'bi-house-heart',
  },
  {
    titulo: 'Luto e momentos de mudança',
    descricao:
      'Suporte para atravessar perdas, separações, mudanças de cidade e outras transições que desorganizam a vida.',
    icone: 'bi-flower2',
  },
  {
    titulo: 'Maternidade e paternidade',
    descricao:
      'Apoio nas fases de tentar engravidar, gestação, puerpério e criação dos filhos, incluindo o retorno ao trabalho.',
    icone: 'bi-heart',
  },
  {
    titulo: 'Orientação e transição de carreira',
    descricao:
      'Apoio para mudar de área, voltar ao mercado ou redefinir objetivos, com clareza sobre valores, interesses e próximos passos.',
    icone: 'bi-signpost-split',
  },
  {
    titulo: 'Liderança, burnout e estresse no trabalho',
    descricao:
      'Suporte para novos desafios profissionais, pressão, esgotamento e equilíbrio entre vida pessoal e profissional.',
    icone: 'bi-briefcase',
  },
  {
    titulo: 'Avaliação DISC',
    descricao:
      'Mapeamento do perfil comportamental: como você age, se comunica e toma decisões, com seus pontos fortes e aspectos a desenvolver.',
    icone: 'bi-bar-chart-line',
  },
];

export default function Servicos() {
  useEffect(() => {
    AOS.init({ once: false });
  }, []);

  return (
    <section
      id="servicos"
      className="bg-verde-novo py-5"
      aria-label="Serviços de terapia para adultos, adolescentes e idosos"
    >
      <div className="container">

        <div className="text-center mb-5 mx-auto" style={{ maxWidth: '720px' }}>
          <h2 className="text-marrom-suave mb-3">
            Como posso te apoiar?
          </h2>
          <p className="text-muted mb-0">
            Terapia online para adultos, adolescentes e idosos, além de orientação de carreira e avaliação DISC.
          </p>
        </div>

        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">

          {servicos.map((s, i) => (
            <div
              className="col"
              key={i}
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 100}
              data-aos-duration="800"
            >
              <div className="card h-100 shadow-sm border-0 text-center d-flex flex-column justify-content-between">

                <div className="card-body d-flex flex-column justify-content-center">

                  <div className="mb-3">
                    <i className={`bi ${s.icone} fs-1`} style={{ color: '#1f6f66' }}></i>
                  </div>

                  <h3 className="card-title h5 text-marrom-suave">
                    {s.titulo}
                  </h3>

                  <p className="card-text">
                    {s.descricao}
                  </p>

                </div>

              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}
